import React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

export default function booleanColumn({ label, value }) {
	return [{
		name: value,
		label: label,
		options: {
			filterType: 'checkbox',
			customBodyRowRender: cellValue => cellValue ? 'Yes' : 'No'
		},
	}, {
		name: value,
		label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: cellValue => (
				<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					<IconSeeker icon={cellValue ? "circle-check" : "circle-xmark"} sx={{ color: cellValue ? "colors.green" : "colors.red" }}/>
				</Box>
			),
		},
	}]
}
